<template>
  <div>
      <v-card>
        <v-card-title>
          <h3 class="secondary--text">{{ $t('stream.enforce_movie.title') }}</h3>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outline
            small
            @click="enforceMovie()"
            >{{ $t('stream.enforce_movie.btn') }}</v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <ul>
            <li>{{ $t('stream.enforce_movie.inst_1') }}</li>
            <li>{{ $t('stream.enforce_movie.inst_2') }}</li>
          </ul>
        </v-card-text>
      </v-card>
    </div>
</template>
<script>
export default {
  props: ["screener_id", "streams"],
  name: "EnforceMovie",
  methods: {
    async enforceMovie(){
      try {
        if (this.$route.params.screener_id == undefined) {
          throw {
            message: "Please create the screener before enable the stream"
          };
          return;
        }
        var stream = {
          type : 'MovieStream'
        };
        /**
         * remove force from other stream if there any
         */
        this.$emit("removeForceStream", stream);
        /**
         * broadcast
         */
        var result = await this.$store.dispatch("screener/broadcastStream", {
          id: this.screener_id,
          stream: stream,
          streams: this.streams
        });
        this.$store.dispatch("app/showMessage", {
          message: this.$t("stream.enforce_movie.message_success"),
          color: "success"
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

  }
}
</script>
